import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from '../admin-available-modals';

@Component({
    selector: 'app-seat-limit-reached',
    templateUrl: './seat-limit-reached.component.html',
    standalone: false
})
export class SeatLimitReachedComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('seatLimitReachedModal', { static: true }) public modalView: ModalDirective;

  ngAfterViewInit() {
    this.modalId = AdminAvailableModals.SEAT_LIMIT_REACHED;
    this.modalView.show();
  }
}
